var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('span',{staticClass:"my-15 text-body-1 text--disabled",domProps:{"textContent":_vm._s(_vm.$t(_vm.message))}})])}
var staticRenderFns = []

export { render, staticRenderFns }